import styled from "styled-components";

export const StyledUserLoginForm = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 724px;
  flex: 1;

  .button {
    width: 35%;
  }
  .input {
    width: 65%;
  }

  @media only screen and (max-width: 600px) {
    .input, .button {
      width: 100%;
    }
  }
`;